import { render, staticRenderFns } from "./MobileTabBar.vue?vue&type=template&id=1d0364d1&scoped=true"
import script from "./MobileTabBar.vue?vue&type=script&lang=ts"
export * from "./MobileTabBar.vue?vue&type=script&lang=ts"
import style0 from "./MobileTabBar.vue?vue&type=style&index=0&id=1d0364d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0364d1",
  null
  
)

export default component.exports